import { useHightouchOrganization } from 'api/HightouchAPI';
import { UserContextProject, selectUserProject } from 'core/userContext';
import { BillingQueryContext } from 'modules/dataWarehouse/contexts/BillingQueryContext';
import { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { getCurrentProjectStatus, getRemainingSyncs } from '../utils';

export const BillingQueryContextProvider = ({ children }: { children: ReactNode }) => {
  /** Hightouch organization */
  const { data: hightouchOrg, isError, isLoading } = useHightouchOrganization();

  const remainingSyncs = hightouchOrg ? getRemainingSyncs(hightouchOrg.organization) : 0;

  const currentProject = useSelector(selectUserProject) as UserContextProject;
  const currentProjectStatus = getCurrentProjectStatus(currentProject?.id, hightouchOrg?.projects);

  const value = {
    currentProjectStatus,
    isError,
    isLoading,
    hightouchOrg,
    remainingSyncs,
  };
  return <BillingQueryContext.Provider value={value}>{children}</BillingQueryContext.Provider>;
};
